import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isAuthenticated: false,
    showDialog: false,
    showReleaseNotes: false,
    dialogText: '',
    titleText: '',
    user: null, // Initial state is null
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setReleaseNotesFalse(state) {
      state.showReleaseNotes = false;
    },
    setAuthentication(state, value) {
      state.isAuthenticated = value;
    },
    toggleDialog(state, payload) {
      state.showDialog = payload.show;
      if (payload.text) {
        state.dialogText = payload.text;
      }
      if (payload.titleText) {
        state.titleText = payload.titleText;
      }
    },
  },
  actions: {
    setUser(context, user) {
      context.commit('setUser', user);
    }
  },
  getters: {
    getUser: (state) => state.user,
    userGroups: (state) => (state.user ? state.user.groups : []),
  },
});

export default store;
